import { useRouter } from 'next/router';
import { ReactElement, useState } from 'react';

import AuthenticationLayout from '@/components/layouts/authentication-layout';
import PageLayout from '@/components/layouts/page-layout';
import { Form } from '@/components/password-recovery/form';
import { ErrorAlert } from '@/components/shared-components/alerts/error-alert';
import { api } from '@/services/axios';
import { PasswordRecoveryService, RequestResponse } from '@/services/password-recovery-service';

interface IFormInputs {
  email: string;
}

export default function PasswordRecovery() {
  const router = useRouter();
  const [error, setError] = useState(false);

  const onSubmit = async ({ email }: IFormInputs) => {
    const service = new PasswordRecoveryService(api);
    const { isSuccess }: RequestResponse = await service.request(email);

    if (isSuccess) router.push('/password-recovery/email-sent');
    else setError(true);
  };

  return (
    <>
      {error && <ErrorAlert text={'E-mail não cadastrado!'} />}
      <AuthenticationLayout
        tittle={'Recuperar senha'}
        subTittle={'Digite seu e-mail e receba um link pra recuperar sua senha'}
      >
        <Form onSubmit={onSubmit} />
      </AuthenticationLayout>
    </>
  );
}

PasswordRecovery.getLayout = (page: ReactElement) => {
  return <PageLayout title="Recuperação de senha - Kenzie Backoffice">{page}</PageLayout>;
};
